/**
 * Identity Server Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuthMethodType } from './authMethodType';


export interface PasscodeEmailAuthMethodViewModel { 
    id?: number;
    type?: AuthMethodType;
    sequence?: number;
    isDefault?: boolean;
    awaitingEnrollment?: boolean;
    revertAtTime?: string | null;
    emailAddress?: string | null;
}

